export default (function(debug, infoLog, eventLog) {
    if (window.klaviyo === undefined) {
        if (debug)
            infoLog(
                'Not registering ViewProduct-Klaviyo Listener. _learnq unavailable.'
            );
        return false;
    }

    if (debug) infoLog('Registering ViewProduct-Klaviyo Listener');

    window.addEventListener('ViewProduct', event => {
        if (debug) eventLog(`View Product Klaviyo`, event);

        const {
            productURL,
            imageUrl,
            productId,
            sku,
            productPrice,
            productCompareAtPrice,
            productCategory,
            productTitle,
            handle,
            quantity,
        } = event.detail;

        const KlaviyoItem = {
            $value: productPrice,
            Name: productTitle,
            Handle: handle,
            ID: productId,
            SKU: sku,
            Categories: productCategory ? [productCategory] : [],
            ImageURL: imageUrl,
            URL: productURL,
            Brand: 'MAAP',
            Price: productPrice,
            CompareAtPrice: productCompareAtPrice,
            Quantity: quantity,
            Metadata: {
                Brand: 'MAAP',
                Price: productPrice,
                CompareAtPrice: productCompareAtPrice,
            },
        };

        klaviyo.push(['track', 'Viewed Product', KlaviyoItem]);

        klaviyo.push(['trackViewedItem', KlaviyoItem]);
    });

    return true;
});
